<template>
	<v-data-table
		:headers="headers"
		:items="users"
		:loading="loading"
		class="elevation-1"
		:mobile-breakpoint="0"
	>
		<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
		<user-row slot="item" :show-organization="isAdmin" slot-scope="props" @edit="onEdit" :user="props.item"/>
	</v-data-table>
</template>

<script>
	import UserRow from "src/view/users/UserRow";
	import {types} from "src/store/modules/User.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "users-table",
		props: [],
		components: {
			UserRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				loading: false,

				search: null,
				showDialog: false
			};
		},
		computed: {
			users() {
				return this.$store.state.UserModule.users;
			},
			isAdmin() {
				return this.$store.getters.isAdmin;
			},
			headers() {
				let headers = [
					{text: "שם", value: "name"},
					{text: "שם משפחה", value: "last_name"},
					{text: "שם משתמש", value: "username"},
					{text: "מרכז", value: "company.name"}
				];
				if (this.isAdmin) {
					headers.push({text: "שם ארגון", value: "organizations_name"});
				}
				return [...headers, ...[{text: "פעולות"}]];
			},
		},
		methods: {
			onEdit(User) {
				this.$emit("edit", User);
			}
		}
	};
</script>

<style>

</style>
